


























































// vendor
import { format } from "date-fns";
import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
// project
import { Asset, AssetVersion } from "@/psychlab/types";
import { ViewAssetHistoryModal, IAssetHistoryModal } from "@/components.assets/view-asset-history-modal";

export default defineComponent({
	props: {
		blueprint: {
			type: Object as PropType<Asset>,
			required: true,
		},
		blueprintVersion: {
			type: Object as PropType<AssetVersion<any>>,
			required: true,
		},
	},
	components:{
		ViewAssetHistoryModal,
	},
	setup(props) {

		const historyModal = ref<IAssetHistoryModal>();

		const createdFormatted = computed(() =>
			props?.blueprint?.created
				? format(new Date(props.blueprint.created), "MM/dd/yy")
				: "",
		);

		const openHistory = () => {
			if(!historyModal.value){ return; }
			historyModal.value.open({
				asset:props.blueprint._id,
				version:props.blueprintVersion._id,
			});
		};

		return {
			historyModal,
			createdFormatted,
			openHistory,
		};
	},
});
